module.exports = __webpack_public_path__ + "media/application/images/svgs/facebook-contact-e1a1485cf01f497e91a4bd61cb3614fd.svg";